import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { AiOutlinePlus } from "react-icons/ai";

import carInspectionImg from "../../Assets/carInspectionImg.png";
import { Header } from "../../Components";
import {
  MainContainer,
  MainDownContainer,
  ImageBackgroundVehicleInspection,
  ContentVehicleInspection,
  ContentFooterareaInspectionInstruction,
  MainBgInsertDetails,
} from "./style.js";
import "./style.css";
import OfferPopup from "./OfferPopup";
import {getUserStatus} from "../../actions/auth";

const InspectionInstructionScreen = () => {
  const history = useHistory();
  const [showOffer, setShowOffer] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [rotation, setRotation] = useState(0);

  useEffect(() => {
    if (isLoading) {
      const interval = setInterval(() => {
        setRotation(prev => prev + 10);
      }, 50);
      return () => clearInterval(interval);
    }
  }, [isLoading]);

  const isMysterious = localStorage.getItem("isMysterious") === "true";

  useEffect(() => {
    const initializeComponent = async () => {
      try {
        const userStatus = await getUserStatus();
        const isNewUser= userStatus.data.isNewUser;
        if (isNewUser && !isMysterious) {
          setShowOffer(true);
        } else {
          setShowOffer(false);
        }
      } catch (error) {
        console.error('Error initializing component:', error);
        setShowOffer(false);
      } finally {
        setIsLoading(false);
      }
    };

    initializeComponent();
  }, [isMysterious]);

  const handleCloseOffer = () => {
    setShowOffer(false);
  };

  if (isLoading) {
    return (
      <MainContainer>
        <ImageBackgroundVehicleInspection>
          <MainBgInsertDetails>
            <ContentVehicleInspection>
              <Header title={true} />
            </ContentVehicleInspection>
            <MainDownContainer>
              <div style={{ 
                textAlign: 'center', 
                padding: '50px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}>
                <div style={{
                  width: '40px',
                  height: '40px',
                  border: '4px solid #f3f3f3',
                  borderTop: '4px solid #3498db',
                  borderRadius: '50%',
                  transform: `rotate(${rotation}deg)`
                }}></div>
              </div>
            </MainDownContainer>
          </MainBgInsertDetails>
        </ImageBackgroundVehicleInspection>
      </MainContainer>
    );
  }

  return (
    <MainContainer>
      <ImageBackgroundVehicleInspection>
        <MainBgInsertDetails>
          <ContentVehicleInspection>
            <Header title={true} />
          </ContentVehicleInspection>

          <MainDownContainer>
            <ContentFooterareaInspectionInstruction>
              <div className="inspectionInstructionHeading">
                Before You Start
              </div>
              <div>
                <div className="inspectionInstructionContentContainer">
                  <div>
                    <img
                      className="carinspectionInstructionImg"
                      src={carInspectionImg}
                      alt="Car inspection"
                    />
                  </div>
                  <div
                    style={{
                      background: "white",
                      padding: 10,
                      paddingBottom: 70,
                      position: "relative",
                      borderRadius: "5px",
                    }}
                  >
                    <div>
                      <div>
                        <div className="inspectionInstructionContentHeading">
                          Minimum Vehicle Requirement
                        </div>
                        <div className="inspectionInstructionContentText">
                          <ul>
                            <li>
                              15 year old vehicle or newer (10 year old or newer
                              for HopSkipDrive)
                            </li>
                            <li>4-door vehicle</li>
                            <li>
                              Good condition with no major cosmetic damage
                            </li>
                            <li>No commercial branding (Uber & Lyft only)</li>
                          </ul>
                        </div>
                      </div>
                      <div className="inspectionInstructionContentStyling">
                        <div className="inspectionInstructionContentHeading">
                          Camera Access for the Mobile Browser
                        </div>
                        <div className="inspectionInstructionContentText">
                          Your camera may be disabled in your phone settings. In
                          order to make sure your camera is functional, please
                          follow the steps below:
                        </div>
                      </div>
                      <div className="inspectionInstructionContentStyling">
                        <div className="inspectionInstructionContent">
                          Settings &gt; Browser (Chrome, Firefox etc) &gt; Allow Camera
                        </div>
                      </div>
                      <div className="inspectionInstructionContentStyling">
                        <div className="inspectionInstructionContentHeading">
                          Things you will require
                        </div>
                        <div className="inspectionInstructionContentText">
                          <ul>
                            <li>
                              Vehicle Registration Card (Photo of VIN may
                              suffice)
                            </li>
                            <li>A Penny or a Quarter coin</li>
                            <li>
                              An object large enough to hold a phone (for rear
                              video)
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="inpection-instruction-btn-container">
                  <div className="inspection-btn-align">
                    <div
                      className="inspection-btn-container"
                      onClick={() => {
                        history.push(`/selectCompany/${false}`);
                      }}
                    >
                      <AiOutlinePlus color="white" size={22} />
                      <div className="inspections-btn-text">New Inspection</div>
                    </div>
                  </div>
                </div>
              </div>
            </ContentFooterareaInspectionInstruction>
          </MainDownContainer>
        </MainBgInsertDetails>
      </ImageBackgroundVehicleInspection>

      {/* Offer Popup */}
      <OfferPopup
        visible={showOffer}
        onClose={handleCloseOffer}
        onContinue={() => {
          history.push(`/selectCompany/${false}`);
        }}
      />
    </MainContainer>
  );
};

export default InspectionInstructionScreen;